import React from 'react';
import { Settings as SettingsIcon, XIcon, SparklesIcon, ChevronRightIcon } from 'lucide-react';
interface CustomizeModalProps {
  isOpen: boolean;
  onClose: () => void;
}


const APP_URL = import.meta.env.VITE_API_BASE_URL

export const CustomizeModal: React.FC<CustomizeModalProps> = ({
  isOpen,
  onClose
}) => {

  const handleSignupLink = () => {
    window.open(`${APP_URL}/users/register`, '_blank');
  }

  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} />
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl shadow-xl max-w-2xl w-full overflow-hidden">
          <div className="flex items-center justify-between p-6 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <div className="bg-purple-50 p-2 rounded-lg">
                <SettingsIcon className="text-purple-600" size={20} />
              </div>
              <h2 className="text-xl font-semibold text-gray-900">
                Customize Avatar
              </h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close">
              <XIcon size={20} />
            </button>
          </div>
          <div className="p-6">
            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-xl p-6 mb-6">
              <div className="flex items-start gap-4">
                <div className="bg-purple-100 rounded-full p-2">
                  <SparklesIcon className="text-purple-600" size={24} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-1">
                    Premium Customization
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    Unlock advanced controls to create your perfect digital twin
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-900 mb-2">
                      Gender
                    </label>
                    <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-400 cursor-not-allowed group">
                      <span>Select gender</span>
                      <ChevronRightIcon size={18} className="text-gray-300 group-hover:text-gray-400" />
                    </button>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-900 mb-2">
                      Age Range
                    </label>
                    <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-400 cursor-not-allowed group">
                      <span>Choose age</span>
                      <ChevronRightIcon size={18} className="text-gray-300 group-hover:text-gray-400" />
                    </button>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-900 mb-2">
                      Style
                    </label>
                    <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-400 cursor-not-allowed group">
                      <span>Select style</span>
                      <ChevronRightIcon size={18} className="text-gray-300 group-hover:text-gray-400" />
                    </button>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-900 mb-2">
                      Expression
                    </label>
                    <button className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-400 cursor-not-allowed group">
                      <span>Choose expression</span>
                      <ChevronRightIcon size={18} className="text-gray-300 group-hover:text-gray-400" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-8 text-center">
                <button onClick={handleSignupLink} className="w-full sm:w-auto px-6 py-3 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 transition-colors shadow-sm">
                  Sign Up to Customize
                </button>
                <p className="mt-3 text-sm text-gray-500">
                  Get access to all premium features and customization options
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
